import React, { useMemo } from 'react';
import { Input } from '@Sage/hoi-poi-ui';

function Integer({ onBlur, ...props }) {
    const overrides = useMemo(
        () => ({
            input: {
                onKeyPress: (e) => {
                    e = e || window.event;
                    const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
                    const charStr = String.fromCharCode(charCode);
                    if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
                },
                onBlur: (e) => {
                    const value = e.target?.value ? parseInt(e.target.value, 10) : null;
                    onBlur && onBlur({ ...e, target: { ...e.target, value } });
                },
            },
        }),
        [onBlur],
    );

    return (
        <Input
            labelMode="horizontal"
            type="number"
            placeholder="0"
            overrides={overrides}
            {...props}
        />
    );
}

export default Integer;
